export const principles = [
  { title: 'Start with the process.', body: 'Understand how the work happens before selecting the implementation.' },
  { title: 'Keep the scope clear.', body: 'Define responsibilities, costs, and limits before building.' },
  {
    title: 'Make the handoff useful.',
    body: 'Document how the assistant operates, who owns it, and what ongoing support requires.',
  },
];
